import * as React from "react"

import { isNumber } from "../../../../../../util/Strings"

import UnavailableLink from "../UnavailableLink"

import Concept from "./Concept"
import CreateInConcept from "./CreateInConcept"

interface Props {
    attributes: Record<string, string>
    customLabel: string
    label: string
    linkParameters: string[]
}

export const ConceptInternalLink = ({
    attributes,
    customLabel,
    label,
    linkParameters,
}: Props): JSX.Element => {
    if (linkParameters.length === 2 && isNumber(linkParameters[1])) {
        // LIST.[LISTID] => OPENS THE GIVEN LIST ON THE LAST ACCESSED TAB
        return (
            <Concept
                attributes={attributes}
                customLabel={customLabel}
                label={label}
                conceptId={parseInt(linkParameters[1])}
            />
        )
    } else if (
        // LIST.CREATE.[LISTID] => CREATE NEW ITEM IN THE GIVEN LIST
        linkParameters.length === 3 &&
        linkParameters[1] === "create" &&
        isNumber(linkParameters[2])
    ) {
        return (
            <CreateInConcept
                attributes={attributes}
                label={label}
                conceptId={parseInt(linkParameters[2])}
            />
        )
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default ConceptInternalLink
